/**
 * Converts the given {@link date} to a ABAP specific date type.
 */
export const toABAPDate = (date: Date): string => {
  const offset = date.getTimezoneOffset();
  const convertedDate = new Date(date.getTime() - offset * 60 * 1000);
  const result = convertedDate.toISOString().split("T")[0];
  return result.replaceAll("-", "");
};
